import styled from '@emotion/styled'

export const DayWrapper = styled.div`
  border-right: 1px solid #c9c9c9;
  display: flex;
  flex-grow: 1;
  min-width: 69px;
`
